// extracted by mini-css-extract-plugin
module.exports = {"swiperWrap":"swiperWrap--5FUBD","carouselItem":"carouselItem--3CSfS"};